import { createSelector } from 'reselect';
import { pendingResponse } from '../fetchStatus';

const redirectSelector = state => state?.redirects;

export const redirectsResponseSelector = createSelector([redirectSelector], redirects => redirects ?? pendingResponse);

export const redirectsSelector = createSelector([redirectsResponseSelector], redirects => redirects.data ?? []);
